import React from 'react';
import { HandHeart, Users, Sparkles, Heart } from 'lucide-react';

/**
 * Sage Green impact section — "Hope in numbers" style, subtle metrics for the L3C mission.
 */
const stats = [
  { icon: HandHeart, num: 'L3C',         label: 'Social Enterprise',         labelClass: '' },
  { icon: Users,     num: 'By',          label: 'Adults with\nSpecial Needs', labelClass: 'whitespace-pre-line' },
  { icon: Sparkles,  num: 'Every',       label: 'Purchase is\nSpecial',       labelClass: 'whitespace-pre-line' },
  { icon: Heart,     num: 'Since',       label: 'A Vision\nin 2023',       labelClass: 'whitespace-pre-line' },
];

const ImpactSection = () => {
  return (
    <section className="py-20 md:py-24 bg-brand-sage text-white relative overflow-hidden" data-testid="home-impact">
      <div className="absolute inset-0 opacity-25 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 20% 30%, rgba(255,255,255,0.4), transparent 55%), radial-gradient(circle at 80% 70%, rgba(212,166,58,0.35), transparent 55%)',
      }} />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="text-[11px] uppercase tracking-[0.3em] text-brand-cream mb-4">Hope in Motion</div>
          <h2 className="font-serif-display text-4xl md:text-5xl text-white leading-tight">
            Every purchase creates <span className="italic text-white underline decoration-brand-gold decoration-2 underline-offset-4">meaningful work</span>.
          </h2>
          <p className="mt-5 text-white/80 leading-relaxed">
            We are an L3C social enterprise creating meaningful employment for adults with special needs — sharing the hope of Christ through every product we make.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="bg-white/10 backdrop-blur rounded-2xl p-6 text-center border border-white/20">
                <Icon className="w-6 h-6 text-brand-gold mx-auto mb-3" />
                <div className="font-serif-display text-3xl md:text-4xl text-brand-gold">{s.num}</div>
                <div className={`text-[11px] uppercase tracking-[0.2em] text-white/90 mt-2 leading-relaxed ${s.labelClass || ''}`}>{s.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
